import { Eye, EyeOff } from "lucide-react";
import { Badge, IconButton, useToast } from "@/components/ui";
import { useMembers } from "@/lib/members";
import { useMe, useUpdatePrefs } from "@/lib/queries";

/** Quick switch for "Ocultar cuentas individuales" (only joint accounts count everywhere); not
 *  offered in a one-person household, where there's nobody else's account to hide. */
export function IndividualAccountsToggle() {
  const me = useMe();
  const members = useMembers();
  const update = useUpdatePrefs();
  const toast = useToast();
  const hidden = !!me.data?.hide_individual_accounts;
  if (!me.data || (members.single && !hidden)) return null;
  return (
    <IconButton
      label={hidden ? "Mostrar cuentas individuales" : "Ocultar cuentas individuales"}
      aria-pressed={hidden}
      disabled={update.isPending}
      onClick={async () => {
        await update.mutateAsync({ hide_individual_accounts: !hidden });
        toast(hidden ? "Mostrando todas las cuentas" : "Solo cuentas compartidas");
      }}
    >
      {hidden ? <EyeOff className="size-5" /> : <Eye className="size-5" />}
    </IconButton>
  );
}

/** Reminder shown while individual accounts are hidden, so totals aren't misread. */
export function JointOnlyBadge() {
  const me = useMe();
  if (!me.data?.hide_individual_accounts) return null;
  return (
    <Badge tone="accent">
      <EyeOff className="size-3" aria-hidden />
      Solo cuentas compartidas
    </Badge>
  );
}
